const ChatDisclaimer = ({ className = '', style = {} }) => {
  return (
    <p 
      className={`text-center mt-2 ${className}`}
      style={{ 
        fontSize: '12px', 
        color: '#64748B',
        marginTop: '6px',
        ...style
      }}
    >
      Toda IA pode cometer erros. Confira informações importantes.
    </p>
  );
};

export default ChatDisclaimer;